import React from 'react';
import './src/styles/global.css';
import RootElement from './src/components/root-elemente';

export const wrapRootElement = ({ element }) => {
  return <RootElement>{element}</RootElement>;
};
